import React from 'react'
import { CiSearch } from "react-icons/ci";
import { IoIosNotificationsOutline } from "react-icons/io";
import { FaBars } from "react-icons/fa";

const Navbar = ({ toggleSidebar }) => {
  return (
    <div className='fixed flex flex-row justify-between h-16 items-center top-0 w-full border-b-2 bg-white border-slate-200 z-40'>
      <div className='flex-none w-60 max-sm:!w-56 flex-row justify-between p-3 bg-white-500'>
        <div className='flex flex-row items-cente gap-3'>
        <button
            className="text-gray-600 text-2xl md:hidden"
            onClick={toggleSidebar}
          >
            <FaBars />
          </button>
          <div className=''><img src="/images/logo.png" alt='logo' /></div>
          <p className='text-base font-bold mt-1.5'>ICIEC <span className='font-normal'>AiChat</span></p>
        </div>
      </div>
      <div className=' flex flex-grow pl-10 max-md:hidden'>
          <div className='flex flex-row items-cente relative mt-2 h-10 gap-2 '>
            <input className=' w-80 rounded-md p-3 bg-searchbg text-sm font-normal -ml-6' type='text' placeholder='Search...' style={{color:"#ADAEBC"}}/>
            <CiSearch className='absolute right-3 size-5 top-2.5' style={{color:"#A3A3A3"}}/>
          </div>
      </div>
      <div>
        <div className='flex flex-row gap-3 mr-24 max-md:!mr-4 items-cente'>
          <IoIosNotificationsOutline className='size-5 mt-2' style={{color:"#525252"}}/>
          <img src='/images/user.png' alt='user'/>
        </div>
      </div>
    </div>
  )
}

export default Navbar